// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const FixedAssetsPage = lazy(() => import('./pages/FixedAssetsPage'));
const CostCentersPage = lazy(() => import('./pages/CostCentersPage'));
const IntercompanyPage = lazy(() => import('./pages/IntercompanyPage'));
const ConsolidationPage = lazy(() => import('./pages/ConsolidationPage'));
const BudgetVsActualPage = lazy(() => import('./pages/BudgetVsActualPage'));
const StatementBuilderPage = lazy(() => import('./pages/StatementBuilderPage'));

export const AccountingRoutes: RouteObject = {
  path: 'accounting',
  element: <ModuleGuard moduleId="finance.accounting" />,
  children: [
    { path: 'fixed-assets', element: <FixedAssetsPage />, handle: { crumb: 'Fixed Assets' } },
    { path: 'cost-centers', element: <CostCentersPage />, handle: { crumb: 'Cost Centers' } },
    { path: 'intercompany', element: <IntercompanyPage />, handle: { crumb: 'Intercompany' } },
    { path: 'consolidation', element: <ConsolidationPage />, handle: { crumb: 'Consolidation' } },
    { path: 'budget-vs-actual', element: <BudgetVsActualPage />, handle: { crumb: 'Budget Vs Actual' } },
    { path: 'statement-builder', element: <StatementBuilderPage />, handle: { crumb: 'Statement Builder' } },
  ],
};
